import React from 'react';
import { Chip, createStyles, makeStyles, Theme } from '@material-ui/core';
import { Add, Remove } from '@material-ui/icons';
import { IngredientType } from '../types/IngredientType';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        chipPrimary: {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.common.white,
        },
        chipSecondary: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.common.white,
        },
        chip: {
            maxWidth: '100%',
            width: '100%',
            '& .MuiChip-label': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flex: 1,
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
            }
        },
    })
);

type Props = {
    type: IngredientType;
    text: string;
};

export function CookIngredientChip({ type, text }: Props) {
    const classes = useStyles();
    const icon = type === 'add' ? <Add /> : <Remove />;

    return (
        <Chip
            size="small"
            color={type === 'add' ? 'primary' : 'secondary'}
            icon={icon}
            label={text}
            classes={{
                root: classes.chip,
                colorPrimary: classes.chipPrimary,
                colorSecondary: classes.chipSecondary,
            }}
        />
    );
}
